import { useLazyQuery } from '@apollo/client';
import { GET_ASSISTANCE_PER_TRAINS } from 'store/queries';
import { getAvailableTrainsESForJourney } from 'pages/JourneySearch/JourneySearch.utils';

const useAssistancePerTrainsQuery = () => {
  const [fetchOutbound, { loading: outboundLoading, data: outbound }] = useLazyQuery(GET_ASSISTANCE_PER_TRAINS, {
    fetchPolicy: 'network-only'
  });

  const [fetchInbound, { loading: inboundLoading, data: inbound }] = useLazyQuery(GET_ASSISTANCE_PER_TRAINS, {
    fetchPolicy: 'network-only'
  });

  const handleQueries = async ({ variables: { outboundDate, inboundDate, search } }) => {
    if (outboundDate) {
      const outboundTrains = getAvailableTrainsESForJourney({ travels: search.outbound.journeys });
      await fetchOutbound({
        variables: {
          trainNumbers: outboundTrains,
          departureDate: outboundDate
        }
      });
    }

    if (inboundDate) {
      const inboundTrains = getAvailableTrainsESForJourney({ travels: search.inbound.journeys });
      await fetchInbound({
        variables: {
          trainNumbers: inboundTrains,
          departureDate: inboundDate
        }
      });
    }
  };

  return [
    handleQueries,
    {
      data: { outbound: outbound?.getAssistancePerTrains ?? [], inbound: inbound?.getAssistancePerTrains ?? [] },
      loading: { outbound: outboundLoading, inbound: inboundLoading }
    }
  ];
};

export default useAssistancePerTrainsQuery;
